import { render, staticRenderFns } from "./SearchSVG.vue?vue&type=template&id=f453556a&scoped=true"
import script from "./SearchSVG.vue?vue&type=script&lang=ts"
export * from "./SearchSVG.vue?vue&type=script&lang=ts"
import style0 from "./SearchSVG.vue?vue&type=style&index=0&id=f453556a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f453556a",
  null
  
)

export default component.exports